export function isIntrisingEmail (email) {
  return !!(email && email.endsWith('@intrising.com.tw'))
}



// WEBPACK FOOTER //
// ./src/utils/permissions.js